import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const ContentVocabularyPage = lazy(
  () => import('~/features/content/pages/content-vocabulary-page'),
);

/** Vocabulary sync (taxonomy maintenance jobs) at `/content/settings/vocabulary`. */
export const Route = createFileRoute('/_authenticated/_tenant/content/settings/vocabulary')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <ContentVocabularyPage />
    </Suspense>
  ),
});
